// Utility to format file sizes in a compact form.
// Rules:
// - If size is undefined/null/0 -> returns undefined (caller can hide)
// - If size < 1 MB -> returns '<1MB'
// - Otherwise rounds DOWN to whole MB (e.g., 2.9MB -> '2MB')
// - Uses base 1024 (MiB) but labels as MB for simplicity
export function formatFileSizeCompact(bytes?: number | null): string | undefined {
  if (bytes == null || bytes <= 0) return undefined;
  const oneMB = 1024 * 1024;
  if (bytes < oneMB) return '<1MB';
  const mb = Math.floor(bytes / oneMB); // truncate
  return `${mb}MB`;
}
